import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';
import { TablePropertiesConstants } from '../table-properties.constant';

export class AdminConstants {
    public static NEW_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.NEW_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        tableWithSelection: true
    };

    public static RETURNED_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.RETURNED_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        tableWithSelection: true
    };

    public static ASSIGNED_TO_ME_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.ASSIGNED_TO_ME_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        tableWithSelection: false
    };

    public static INPROGRESS_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_ASSIGNEE,
        tableWithSelection: false
    };

    public static COMPLETED_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_ASSIGNEE_CLOSED_DATE,
        tableWithSelection: false
    };
    public static COMPLETED_REQUESTS_COMPLETED_BY_TO: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_ASSIGNEE_CLOSED_DATE_COMPLETED_BY_TO,
        tableWithSelection: false
    };
    public static DASHBOARD = {
        ...RequestsTypesConstants.DASHBOARD,
        tableColumn: TablePropertiesConstants.DASHBOARD_COLUMNS_WITH_ASSIGNEE,
        tableWithSelection: false
    };
    public static CALL_RECORD_DASHBOARD = {
        ...RequestsTypesConstants.CALL_RECORD_DASHBOARD,
        tableColumn: TablePropertiesConstants.DASHBOARD_COLUMNS_WITH_ASSIGNEE,
        tableWithSelection: false
    };
    public static CALL_RECORD = {
        ...RequestsTypesConstants.CALL_RECORD,
        tableColumn: TablePropertiesConstants.DASHBOARD_COLUMNS_WITH_ASSIGNEE,
        tableWithSelection: false
    };

    public static DASHBOARD_ACCOUNT_MANAGER = {
        ...RequestsTypesConstants.DASHBOARD,
        tableColumn: TablePropertiesConstants.ACCOUNTMANAGER_TABLE_COLUMNS,
        tableWithSelection: false
    };

    public static SECURITY_COORDINATOR_REQUESTS = {
        ...RequestsTypesConstants.SECURITY_COORDINATOR_REQUESTS,
        tableColumn: TablePropertiesConstants.SECURITY_COORDINATOR_REQUESTS_COLUMNS,
        tableWithSelection: false
    };

    public static COMPLETED_HISTORY_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_HISTORY_REQUESTS,
        tableColumn: TablePropertiesConstants.COMPLETED_HISTORY_REQUESTS_COLUMNS,
        tableWithSelection: false
    };

    public static TECHNICAL_OPERATIONS_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.TECHNICAL_OPERATIONS_REQUESTS,
        tableColumn: TablePropertiesConstants.TECHNICAL_OPERATIONS_REQUESTS_COLUMNS,
        tableWithSelection: false
    };
}
